"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplatesContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const messages_request_1 = require("./messages.request");
const messages_response_1 = require("./messages.response");
const c = (0, core_1.initContract)();
exports.MessageTemplatesContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: messages_request_1.CreateMessageTemplateRequestSchema,
        responses: {
            201: messages_response_1.MessageTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findMany: {
        method: 'GET',
        path: '/',
        query: messages_request_1.MessageTemplateListQuerySchema,
        responses: {
            200: messages_response_1.MessageTemplateListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findById: {
        method: 'GET',
        path: '/:templateId',
        pathParams: messages_request_1.MessageTemplateIdPathParamsSchema,
        responses: {
            200: messages_response_1.MessageTemplateResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/:templateId',
        pathParams: messages_request_1.MessageTemplateIdPathParamsSchema,
        body: messages_request_1.UpdateMessageTemplateRequestSchema,
        responses: {
            200: messages_response_1.MessageTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    delete: {
        method: 'DELETE',
        path: '/messages/:templateId',
        pathParams: messages_request_1.MessageTemplateIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/messages' });
